exports.list = {
  path: "/penyelesaian_vulkanisir",
  name: "penyelesaian_vulkanisir",
  meta: {
    authRequired: true,
  },
  component: () => import("@/views/main/penyelesaian_vulkanisir/List.vue"),
};
exports.show = {
  path: "/penyelesaian_vulkanisir/show/:kode",
  name: "penyelesaian_vulkanisir_show",
  meta: {
    authRequired: true,
  },
  component: () => import("@/views/main/penyelesaian_vulkanisir/Show.vue"),
};
  